import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const CustomCursor = () => {
    const dotRef = useRef(null);
    const outlineRef = useRef(null);

    useEffect(() => {
        const dot = dotRef.current;
        const outline = outlineRef.current;

        // Initial setup for Smart Cursor
        gsap.set([dot, outline], {
            xPercent: -50,
            yPercent: -50,
            pointerEvents: 'none',
            zIndex: 9999,
            mixBlendMode: 'difference', // The secret sauce for visibility
            backgroundColor: 'white' // White difference = invert underlying color
        });

        const moveCursor = (e) => {
            gsap.to(dot, {
                x: e.clientX,
                y: e.clientY,
                duration: 0.1,
            });
            gsap.to(outline, {
                x: e.clientX,
                y: e.clientY,
                duration: 0.5,
                ease: "power2.out"
            });
        };

        const hoverEffect = () => {
            gsap.to(outline, {
                scale: 1.5,
                backgroundColor: 'white', // Keep white for difference mode
                duration: 0.3
            });
        };

        const leaveEffect = () => {
            gsap.to(outline, {
                scale: 1,
                backgroundColor: 'white',
                duration: 0.3
            });
        };

        window.addEventListener('mousemove', moveCursor);

        // Add hover listeners to clickable elements
        const clickables = document.querySelectorAll('a, button, .clickable');
        clickables.forEach(el => {
            el.addEventListener('mouseenter', hoverEffect);
            el.addEventListener('mouseleave', leaveEffect);
        });

        return () => {
            window.removeEventListener('mousemove', moveCursor);
            clickables.forEach(el => {
                el.removeEventListener('mouseenter', hoverEffect);
                el.removeEventListener('mouseleave', leaveEffect);
            });
        };
    }, []);

    return (
        <>
            <div ref={dotRef} className="cursor-dot hidden md:block fixed w-2 h-2 rounded-full pointer-events-none"></div>
            <div ref={outlineRef} className="cursor-outline hidden md:block fixed w-8 h-8 border border-white rounded-full pointer-events-none"></div>
        </>
    );
};

export default CustomCursor;
